import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/observable/fromEvent';
import { Http, ResponseContentType } from '@angular/http';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';

import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';


export const DD_MM_YYYY_Format = {
	parse: {
		dateInput: 'LL',
	},
	display: {
		dateInput: 'DD/MM/YYYY',
		monthYearLabel: 'MMM YYYY',
		dateA11yLabel: 'LL',
		monthYearA11yLabel: 'MMMM YYYY',
	},
};

@Component({
	selector: 'Liquidaciones',
	templateUrl: './Liquidaciones.component.html',
	providers: [
		{ provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_Format },
	]
})


export class LiquidacionesComponent {

	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public reportes: Array<{}> = new Array();
	public campos: Array<{}> = new Array();
	public modelo: Array<any> = new Array();
	public nombreReporteXml: string = '';
	public nombreReporte: string = '';
	public link: string = '';

	public cargando: boolean = false;
	public label: string = '';

	public render: boolean = false;
	public cargandoReporte: boolean = false;
	public fechaCierre: string;

	public ocultar: boolean= false;
	public mensaje: string="";


	constructor(private http: Http, private formBuilder: FormBuilder, private _serviciosGenerales: ServiciosGenerales, public snackBar: MatSnackBar,
		private _route: ActivatedRoute, private _router: Router, public dialog: MatDialog) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

		this.snackBar.dismiss();
		this.reportes.push(

			{
				nombreReporte: 'TotalSaldoIndemnizados',
				labelOpcion: 'No. Total y saldo de Indemnizados',
				metadata: 'Año:param_1_string|hidden:param_2_string=param_1_string',
				rutaAlternaServicio: '',
			},
			{
				nombreReporte: 'ValorTotalSaldoCapitaladministrado',
				labelOpcion: 'Vr. Total y saldo del Capital administrado',
				metadata: 'Año:param_1_string|Mes:param_2_string|hidden:param_3_string=param_1_string|hidden:param_4_string=param_2_string',
				rutaAlternaServicio: ''
			},
			{
				nombreReporte: 'ValorTotalSaldoCapitaladministradoBase',
				labelOpcion: 'Vr. Total y saldo del Capital administrado Base',
				metadata: 'Año:param_1_string|Mes:param_2_string|NBase:param_3_string',
				rutaAlternaServicio: ''

			},
			{
				nombreReporte: 'ValorTotalSaldoCapitaladministradoUnique',
				labelOpcion: 'Vr. Total y saldo del Capital administrado Unique',
				metadata: 'Año:param_1_string|Mes:param_2_string|NBase:param_3_string|NUnique:param_4_string',
				rutaAlternaServicio: ''

			},

			{
				nombreReporte: 'DistribucionRequerimientosMensual',
				labelOpcion: 'Distribución de rendimientos mensual',
				metadata: 'Año:param_2_string|Mes:param_1_string|hidden:param_3_string=param_1_string|hidden:param_4_string=param_2_string',
				rutaAlternaServicio: ''
			},
			{
				nombreReporte: 'DistribucionRequerimientosAcumulados',
				labelOpcion: 'Distribución de rendimientos acumulada',
				metadata: 'Año:param_2_string|Mes:param_1_string|hidden:param_3_string=param_1_string|hidden:param_4_string=param_2_string',
				rutaAlternaServicio: ''
			}

		);
	}

	pintar(item: any) {

		let metadata: string;
		metadata = item.metadata;

		console.log(' -- ', metadata);
		this.campos = new Array();
		this.modelo = new Array();

		//console.log(this.modelo[100]);
		if (metadata != '') {
			for (let x of metadata.split('|')) {

				this.modelo.push('');
				let partes = x.split(':');
				let label = partes[0];
				let tipo = partes[1];
				if (label != 'hidden') {
					if (tipo.indexOf('string') > -1) {

						this.campos.push({ labelCampo: label, id: tipo, tipo: 'string', model: parseInt(tipo.substring(tipo.indexOf('_') + 1, tipo.lastIndexOf('_'))) });

					} else if (tipo.indexOf('date') > -1) {

						this.campos.push({ labelCampo: label, id: tipo, tipo: 'date', model: parseInt(tipo.substring(tipo.indexOf('_') + 1, tipo.lastIndexOf('_'))) });

					} else if (tipo.indexOf('list') > -1) {

						let tipoEspecial = tipo.split('=');
						let lista: Array<{}> = new Array();
						for (let y of tipoEspecial[1].split(',')) {
							let temp = y.split('&');
							lista.push({ label: temp[0], value: temp[1] });
						}
						this.campos.push({
							labelCampo: label, tipo: 'list',
							model: parseInt(tipoEspecial[0].substring(tipoEspecial[0].indexOf('_') + 1, tipoEspecial[0].lastIndexOf('_'))),
							value: lista, id: tipo.split('=')[0]
						});
					}
				} else {
					this.campos.push({
						labelCampo: label, id: tipo.split('=')[0], tipo: 'hidden',
						model: parseInt(tipo.split('=')[1].substring(tipo.split('=')[1].indexOf('_') + 1, tipo.split('=')[1].lastIndexOf('_')))
					});
				}
			}
		}
		console.log(this.campos);
	}


	generarReporte(temporal: any) {

		if (this.nombreReporteXml == undefined || this.nombreReporteXml == null || this.nombreReporteXml.split(' ').join('') == '') {
			this.openSnackBarEspecial("Hay que seleccionar un reporte", "X");
			return;
		}
		let parametros = {};

		if (temporal != undefined) {
			parametros = temporal;
		}
		console.log("COMO QUEDA PARAMETRO : ", parametros);

		for (let x of this.campos) {
			console.log('entrá')
			parametros[x['id']] = this.modelo[parseInt(x['model'])];
		}

		console.log("COMO QUEDA parametros : ", parametros);

		for (let x in parametros) {
			if (parametros[x] == undefined || (x.indexOf('date') == -1 ? parametros[x].trim() == '' : parametros[x] == null)) {
				this.openSnackBarEspecial("Hay campos obligatorios sin diligenciar", "X")
				return;
			}

			if (x.indexOf('date') > -1) {
				let fecha = new Date(parametros[x]);
				parametros[x] = fecha.getDate() + '-' + (fecha.getMonth() + 1) + '-' + fecha.getFullYear();
			}
		}
		let rutaAlternaServicio: string = '';

		console.log("COMO QUEDA parametros : ", parametros);

		for (let x of this.reportes) {
			if (x['nombreReporte'] == this.nombreReporteXml) {
				rutaAlternaServicio = x['rutaAlternaServicio'];
			}
		}

		//this._serviciosGenerales.descargarArchivo('generar/excel/' + rutaAlternaServicio + this.nombreReporteXml, parametros);

		var info: string;

		this.cargando = true;
		this.cargandoReporte = true;

		console.log('----------------> ', rutaAlternaServicio + this.nombreReporteXml, parametros);

		this._serviciosGenerales.get('generar/excel/' + rutaAlternaServicio + this.nombreReporteXml, parametros).subscribe(res => {
			console.log("----> ", res);

			if (res.retornoProcedimiento != undefined && res.retornoProcedimiento == true) {
				this.openSnackBar(res.info, "X");
			} else {
				/*info = res['_body'];*/
				info = 'data:application/octet-stream;base64,' + res.info;

				var dlnk = document.getElementById('dwnldLnk');
				dlnk['href'] = info;
				dlnk.click();

			}


			this.cargando = false;
			this.cargandoReporte = false;

		}, error => {
			console.log(error, '');
			this.openSnackBarEspecial("Ocurrió un error al momento de generar el reporte....", "X");
			this.cargando = false;
			this.cargandoReporte = false;
		})
	}


	downloadFile() {
		return this.http
			.get('/facturacion/rest/generar/excel/prueba', {
				responseType: ResponseContentType.Blob,
				search: ''
			})
			.map(res => {
				return {
					filename: 'filename.xlsx',
					data: res.blob()
				};
			})
			.subscribe(res => {
				console.log('start download:', res);
				var url = window.URL.createObjectURL(res.data);
				var a = document.createElement('a');
				document.body.appendChild(a);
				a.setAttribute('style', 'display: none');
				a.href = url;
				a.download = res.filename;
				a.click();
				window.URL.revokeObjectURL(url);
				a.remove(); // remove the element
			}, error => {
				console.log('download error:', JSON.stringify(error));
			}, () => {
				console.log('Completed file download.')
			});
	}

	downloadFile2() {
		return this.http
			.get('/facturacion/rest/generar/excel/prueba2', {
				responseType: ResponseContentType.Blob,
				search: ''
			})
			.map(res => {
				return {
					filename: 'filename.xlsx',
					data: res.blob()
				};
			})
			.subscribe(res => {
				console.log('start download:', res);
				var url = window.URL.createObjectURL(res.data);
				var a = document.createElement('a');
				document.body.appendChild(a);
				a.setAttribute('style', 'display: none');
				a.href = url;
				a.download = res.filename;
				a.click();
				window.URL.revokeObjectURL(url);
				a.remove(); // remove the element
			}, error => {
				console.log('download error:', JSON.stringify(error));
			}, () => {
				console.log('Completed file download.')
			});
	}


	downloadFile4() {

		var info: string;

		this.http
			.get('/facturacion/rest/generar/excel/prueba4').subscribe(res => {
				console.log("OK ");

				info = res['_body'];
				info = 'data:application/octet-stream;base64,' + info;

				var dlnk = document.getElementById('dwnldLnk');
				dlnk['href'] = info;
				dlnk.click();

			}, error => {
				console.log("MAL ");
				console.log(error);
			})

	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef = this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});

		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;

		if (shand.length != 0) {
			for (let i = 0; i < shand.length; i++) {
				shand[i].style.backgroundColor = "rgb(255 204 214)";
			}
		}
	}
}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Liquidaciones/Liquidaciones.component.ts